import { Component, AfterViewInit, Inject, PLATFORM_ID, NgZone } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as AOS from 'aos';

declare var $: any;

@Component({
  selector: 'app-hub',
  templateUrl: './hub.component.html',
  styleUrls: ['./hub.component.css']
})
export class HubComponent implements AfterViewInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private zone: NgZone
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          const gallery = $('#gallery');
          const gallery1 = $('#gallery1');

          if (gallery.length && gallery1.length) {
            gallery.slick({
              slidesToShow: 6,
              slidesToScroll: 1,
              arrows: false,
              autoplay: true,
              autoplaySpeed: 0,
              speed: 4000,
              pauseOnHover: true,
              cssEase: 'linear',
              rtl: true,
              draggable: false,
              swipe: false,
              touchMove: false,
              responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 3 } },
                { breakpoint: 600, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } },
              ],
            });

            gallery1.slick({
              slidesToShow: 6,
              slidesToScroll: 1,
              arrows: false,
              autoplay: true,
              autoplaySpeed: 0,
              speed: 4000,
              pauseOnHover: true,
              cssEase: 'linear',
              draggable: false,
              swipe: false,
              touchMove: false,
              responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 3 } },
                { breakpoint: 600, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } },
              ],
            });

            AOS.init({ duration: 1000, once: true });
          }
        }, 500);
      });
    }
  }
}
